import {Dispatch} from 'react'
import {CREACION_USUARIO_TYPES} from '../../constants/creacionUsuario.types'
import {CreacionUsuarioAction} from '../../interfaces/creacionUsuario.interface'
import * as validacionesRegex from '../../utils/strings.utils'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {State} from '../../reducers'
import {generalOpenModalError, generalShowLoader} from '../general.actions'
import {creacionUsuarioFormAddError} from './validacionesCreacionUsuario.actions'
import {KEYS} from '../../constants/keysStorage'
import {ROL_POR_OMISION, resolverRolID} from '../../constants/roles'

// ******************************************************************************************
export const creacionUsuarioHandleChange = (formUser: any) => ({
  type: CREACION_USUARIO_TYPES.FORM_HANDLE_CHANGE,
  payload: formUser,
})

export const creacionUsuarioVerifyCodeHandleChange = (form: any) => ({
  type: CREACION_USUARIO_TYPES.FORM_VERIFY_CODE_HANDLE_CHANGE,
  payload: form,
})

export const creacionUsuarioChangePage = (num: number) => ({
  type: CREACION_USUARIO_TYPES.FORM_CHANGE_PAGE,
  payload: num,
})

export const creacionUsuarioClear = () => ({
  type: CREACION_USUARIO_TYPES.FORM_CLEAR,
  payload: null,
})

// ******************************************************************************************
export const creacionUsuarioFormHandleChangePhone =
  (phone: string) => async (dispatch: Dispatch<CreacionUsuarioAction>) => {
    dispatch(creacionUsuarioHandleChange({phone_number: phone}))
  }
export const creacionUsuarioFormHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'username':
          if (!validacionesRegex.validarRegexUsername(value)) return
          break
        case 'passwd':
        case 'passwd2':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        case 'birth_date':
          break
        case 'first_name':
        case 'second_name':
        case 'third_name':
        case 'last_name':
        case 'last_name2':
        case 'last_name_married':
          if (!validacionesRegex.validarRegexSoloLetrasEspacio(value)) return
          break
        case 'nit':
          if (!validacionesRegex.validarRegexNumEnteroGuion(value)) return
          break
        case 'tipoDocumento':
          const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
          dispatch(creacionUsuarioHandleChange({id_number: ''}))
          dispatch(creacionUsuarioFormAddError({id_number: ''}))
          if (tipoDoc) dispatch(creacionUsuarioHandleChange({nombreTipoDocumento: tipoDoc.valor}))
          else {
            dispatch(creacionUsuarioHandleChange({nombreTipoDocumento: ''}))
          }
          break
        case 'id_number':
          switch (getState().creacionUsuario.formUser.nombreTipoDocumento?.toLowerCase()) {
            case 'dui':
              value = value.substring(0, 9);
              value = validacionesRegex.ReplaceRegexSinLetras(value)
              break;
            case 'nit':
              value = validacionesRegex.ReplaceRegexSinLetras(value)
            break;
            default:
              value = value.toUpperCase()
              break;
          }

          if (getState().creacionUsuario.formUser.nombreTipoDocumento?.toLowerCase() === 'nit') {
            if (!validacionesRegex.validarRegexNumericoInt(value)) return
          } else {
            if (!validacionesRegex.validarRegexNumIdentificacion(value)) return
          }
          break
        case 'codigo_empresa':
          if (!validacionesRegex.validarRegexNumericoInt(value)) return
          break
        case 'email':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        case 'phone_number':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        case 'location':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break

        default:
          break
      }
    }
    
    dispatch(creacionUsuarioHandleChange({[name]: value}))
  }

export const creacionUsuarioFormVerifyCodeHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>) => {
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'code':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        default:
          break
      }
    }
    dispatch(creacionUsuarioVerifyCodeHandleChange({[name]: value}))
  }

// ==========================================================================================================
// PETICIONES REST
// ==========================================================================================================
export const creacionUsuarioVerificarCodigoEmpresa =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const CodigoEmpresa = getState().creacionUsuario.formUser.codigo_empresa
    const body = {CodigoEmpresa}
    return await http
      .post(ENDPOINTS.CREAR_USUARIO_VERIFICAR_CODIGO_EMPRESA, body)
      .then(async (res: any) => {
        if (res?.body?.Valido) return true
        await dispatch(generalOpenModalError('Código de Empresa Incorrecto'))
        return false
      })
      .catch(async (err: any) => {
        let message = 'Intente nuevamente verificar el código de la empresa'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const creacionUsuario_guardarInformacion =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    // ================================================================================
    const formUser = getState().creacionUsuario.formUser

    // ================================================================================
    // Creación de Usuario preliminar
    const body = {
      codigo_empresa: formUser.codigo_empresa.trim(),
      birth_date: formUser.birth_date,
      first_name: formUser.first_name.trim(),
      second_name: formUser.second_name.trim(),
      third_name: formUser.third_name.trim(),
      last_name: formUser.last_name.trim(),
      last_name2: formUser.last_name2.trim(),
      last_name_married: formUser.last_name_married.trim(),
      type_id_number: formUser?.tipoDocumento?.trim(),
      id_number: formUser.id_number.trim(),
    }

    return await http
      .post(ENDPOINTS.CREAR_USUARIO_PREELIMINAR, body)
      .then(async () => {
        return true
      })
      .catch(async (err) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? 'Los datos tienen incosistencias, intente nuevamente', err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const creacionUsuario_guardarCredencialesUsuario =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    // ================================================================================
    // Validación de Email
    const formUser = getState().creacionUsuario.formUser
    const params = {username: formUser.username.trim()}

    // ================================================================================
    // Creación de Usuario
    const body = {
      codigo_empresa: formUser.codigo_empresa.trim(),
      username: formUser.username.trim(),
      passwd: formUser.passwd,
      type_id_number: formUser?.tipoDocumento?.trim(),
      id_number: formUser.id_number.trim(),
    }

    return await http
      .post(ENDPOINTS.CREAR_USUARIO_CREACION, body)
      .then(async () => {
        http.get(`${ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL}`)
        return true
      })
      .catch(async (err) => {
        let message = 'Los datos tienen incosistencias, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const creacionUsuario_guardarContacto =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    // ================================================================================
    // Validación de Email
    const formUser = getState().creacionUsuario.formUser
    const params = {username: formUser.username.trim()}

    // ================================================================================
    // Creación de Usuario
    const body = {
      codigo_empresa: formUser.codigo_empresa.trim(),
      username: formUser.username.trim(),
      type_id_number: formUser?.tipoDocumento?.trim(),
      id_number: formUser.id_number.trim(),
      email: formUser.email.trim(),
      phone_number: formUser.phone_number.trim(),
      location: formUser.location.trim(),
    }

    return await http
      .post(ENDPOINTS.CREAR_USUARIO_CREACION, body)
      .then(async () => {
        http.get(`${ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL}`)
        return true
      })
      .catch(async (err) => {
        let message = 'Los datos tienen incosistencias, intente nuevamente'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const creacionUsuarioCreacion =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    // ================================================================================
    // Validación de Email
    const formUser = getState().creacionUsuario.formUser
    const params = {username: formUser.username.trim()}

    // ================================================================================
    // Creación de Usuario
    const body = {
      username: formUser.username.trim(),
      passwd: formUser.passwd,
      birth_date: formUser.birth_date,
      first_name: formUser.first_name.trim(),
      second_name: formUser.second_name.trim(),
      third_name: formUser.third_name.trim(),
      last_name: formUser.last_name.trim(),
      last_name2: formUser.last_name2.trim(),
      last_name_married: formUser.last_name_married.trim(),
      type_id_number: formUser?.tipoDocumento?.trim(),
      id_number: formUser.id_number.trim(),
      codigo_empresa: formUser.codigo_empresa.trim(),
      email: formUser.email.trim(),
      phone_number: formUser.phone_number.trim(),
      location: formUser.location.trim(),
      role_access_user: resolverRolID(formUser.role_access_user || ROL_POR_OMISION),
      description: 'Creación de usuario facturador',
    }

    return await http
      .post(ENDPOINTS.CREAR_USUARIO_CREACION, body)
      .then(async () => {
        http.get(`${ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL}?username=${params.username}`)
        localStorage.setItem(KEYS.USERNAME_CLIENTE, params.username)
        return true
      })
      .catch(async (err) => {
        let message = 'Intente nuevamente crear el usuario'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const creacionUsuarioReenviarCodigo =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE)
    const params = {username}
    return await http
      .get(`${ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL}?username=${params.username}`)
      .then(async (res) => {
        return true
      })
      .catch(async (err) => {
        let message = 'Intente nuevamente reenviar el código de verificación'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const creacionUsuarioVerificarCodigoEmail =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const {codeVerify} = getState().creacionUsuario
    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE)

    const body = {
      username,
      code: codeVerify.code.trim(),
    }
    let message = 'Intente nuevamente enviar el código de verificación'

    return await http
      .put(ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL, body)
      .then(async (res: any) => {
        if (res.data) return true
        await dispatch(generalOpenModalError(res.message ?? message))
        return false
      })
      .catch(async (err: any) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
